/** Every screen state expresses loading, error and ready. Derived values are computed, never stored. */
export type SignInState = {
  email: string;
  password: string;
  isSubmitting: boolean;
  error: string | null;
};

export const canSubmit = (state: SignInState): boolean =>
  state.email.trim().length > 0 && state.password.length > 0 && !state.isSubmitting;
